<template>
    <v-container fluid>
        <address-form
            :model="address"
            @saved="saved"
            :titlePrefix="$t('forms.title_prefix.edit')"
            v-if="address"
        ></address-form>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import AddressModel from '@/models/Address'
import AddressForm from './Form'

export default {
    props: {
        id: {
            required: true,
        },
    },

    data: () => {
        return {
            address: null,
        }
    },

    components: {
        AddressForm,
    },

    methods: {
        async getAddress() {
            let address = await this.model.find(this.id)

            this.address = address
        },

        saved() {
            this.$router.go(-1)
        },
    },

    computed: {
        model() {
            return new AddressModel()
        },
    },

    created() {
        this.getAddress()
    },
}
</script>

<style></style>
